import * as React from "react";
import mkTracker from "ouisys-clients/dist/pacman/record"
import HOC, {
  initialState,
  mockedSuccessState,
  mockedFailureState,
  mockedLoadingState,
  HOCProps,
  IKeywordShortcode
} from "ouisys-clients/dist/clients/tallyman.v1-click2sms/HOC"
import { TranslationProvider, Translate, legals } from "./localization/index";
import * as RDS from "ouisys-clients/dist/common-types/RemoteDataState";

//Components
import Disclaimer from "ouisys-clients/dist/clients/legal-components/disclaimers";
import TopLegals from "ouisys-clients/dist/clients/legal-components/top-legals";
import PricePoint from "ouisys-clients/dist/clients/legal-components/price-point";
import PreLander from "./components/PreLander";

//Utilities
import searchToObject from "./utils/searchToObject";

//Styling
import "./Root.scss";
import Loader from "./components/PreLander/Loader";
import tryGetIPRangeName from "ouisys-clients/dist/ips/tryGetIPRangeName";

const Video = require("./assets/imgs/video-play.png");
const VideoFull = require("./assets/imgs/video-play-full.jpg");
const videoplayer = require("./assets/imgs/player-bar.png");
const search = require("./assets/imgs/search.svg");
const play = require("./assets/imgs/play.svg");
const load = require("./assets/imgs/spinner1.svg");


const tracker = mkTracker(
  typeof window != "undefined" ? window : null,
  process.env.country,
  process.env.page
);



class Root extends React.PureComponent<HOCProps> {
  state = {
    locale: "en",
    skipPrelander: false,
    videoStatic: 1,
    videoLoad: 0,
    showDiv: 0
  };


  componentWillMount() {
    this.checkSkipPrelander();

    // IP detection
    if (typeof window != "undefined") {
      tryGetIPRangeName(window.pac_analytics.visitor)
        .then((n: string) => {
          const c = n.split("_").length > 0 ? n.split("_")[0] : "xx";
          if (c.toLowerCase() == "eg") {
            this.setState({
              locale: "ar"
            });
          }

          if (c.toLowerCase() == "mx") {
            this.setState({
              locale: "es"
            });
          }

        })
        .catch(x => {
          console.warn(x)
        })
    }

    if (/^es\b/.test(navigator.language)) {
      this.setState({
        locale: "es"
      })
    }
  }

  showLoad = () => {
    tracker.advancedInPreFlow("click-play")
    this.setState({
      videoLoad: 1,
      videoStatic: 0,
      showDiv: 1
    })
  }

  //Show or hide pre-lander
  checkSkipPrelander() {
    const search = searchToObject();
    if (search["skip-prelander"]) {
      this.setState({
        skipPrelander: (search["skip-prelander"] === "true") ? true : false
      })
    }
  }
  render() {
    const MOLink = this.props.MOLink
    const { keyword, shortcode } = RDS.WhenSuccess<IKeywordShortcode, IKeywordShortcode>(
      { keyword: "", shortcode: "" },
      kw => kw
    )(this.props.currentState)
    return (
      <TranslationProvider locale={this.state.locale}>
        <div>

          {/* pre-lander */}
          {/* {
            !this.state.skipPrelander &&
            <PreLander/>
          } */}

          <TopLegals className="top-legals" locale={this.state.locale} legals={legals} />

          {/* <div className="language-switcher-container">
            <button type="button" className="language-switcher"
              onClick={() => {
                if (this.state.locale === "en") {
                  this.setState({ locale: "ar" })
                  document.getElementsByTagName('html')[0].setAttribute("lang", "ar")
                } else {
                  this.setState({ locale: "en" })
                  document.getElementsByTagName('html')[0].setAttribute("lang", "en")
                }
                tracker.advancedInPreFlow("clickLang");
              }}
            >{
                this.state.locale === "ar"
                  ? "EN"
                  : "عربى"
              }</button>
          </div> */}


          <div className="header">
            <img src={search} />
          </div>

          <div className="wrapper">

            <div id="videoPlay" className={" " + (this.state.videoStatic === 1 ? "show" : "hide")} onClick={this.showLoad}>
              <div id="videoPlayerMobile" className="video-player mobile">
                <img src={Video} />
                <img src={play} className="play" />
              </div>
              <div id="videoPlayerWeb" className="video-player web">
                <img src={VideoFull} />
                <img src={play} className="play" />
                <div className="video-control">
                  <img src={videoplayer} />
                </div>
              </div>
            </div>

            <div id="videoLoad" className={" " + (this.state.videoLoad === 1 ? "show" : "hide")}>
              <div id="videoPlayerMobileLoad" className="video-player mobile">
                <img src={Video} />
                <img src={load} className="play" />
              </div>
              <div id="videoPlayerWebLoad" className="video-player web">
                <img src={VideoFull} />
                <img src={load} className="play" />
                <div className="video-control">
                  <img src={videoplayer} />
                </div>
              </div>
            </div>

            <div id="showDiv" className={"oc2sms-wrapper fade-in " + (this.state.showDiv === 1 ? "show" : "hide")}>
              <h1><Translate id="registerText" defaultMessage="You are not registered yet!" /></h1>
              <h2><Translate id="watchMovie" defaultMessage="Click the button below and send activation SMS to get access to our AD-FREE streaming product" /></h2>

              <MOLink className="cta-a-tag btn submit-button">
                <Translate id="sms_now" defaultMessage="Send Activation SMS Now" />
              </MOLink>

              <PricePoint className="price-point" locale={this.state.locale} legals={legals} />
            </div>

            <Disclaimer className="disclaimer" locale={this.state.locale} legals={legals} />
          </div>
          {
            RDS.WhenLoading(null, () => <div>
              <Loader />
            </div>)(this.props.currentState)
          }
        </div>
      </TranslationProvider>
    );
  }
}
//@ts-ignore
export default HOC(tracker, Root, { isclick2smsLoadOnClick: true })(initialState);

// In the Netherlands use this instead of the above line:
// export default HOC(tracker, Root, {tag: "keywordAndShortCode", shortcode: "8010", keyword: "Geld"})(initialState);
